import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IndicadorClienteEditarComponent } from './indicador-cliente-editar.component'; 


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: IndicadorClienteEditarComponent }
    ])],
    exports: [RouterModule]
})
export class IndicadorClienteEditarRoutingModule { }
